// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"styles_fullWidth__3vsFU"};